<template>
  <div>
    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th>Action</th>
              <th>Author</th>
              <th>Created at</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="event in events" :key="event.id">
              <td>{{ event.id }}</td>
              <td>{{ event.action }}</td>
              <td>{{ event.author }}</td>
              <td>{{ event.createdAt | datetime }}</td>
              <td>
                <button class="btn btn-outline" @click="show(event.id)">
                  Show
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
          @pagination="pagination" />
      </div>
    </div>

    <ShowDataModal v-model="showModal" header="Event" :data="currentEvent" :deep="3" />
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import GetUser from '@/mixins/GetUser'
import Pagination from '@/components/shares/specialTag/Pagination'

import ShowDataModal from '@/components/admin/ShowDataModal'
import EntityProxy from '@/models/EntityProxy'

export default {
  components: { Pagination, ShowDataModal },
  computed: {
    events() {
      return EntityProxy.build(this.getModels || [])
    },
    currentAxios() {
      return this.axios.v3
    },
  },
  created() {
    this.$set(this.query, 'periodType', 'created_at')
    this.addOrderBy('created_at')
    this.find()
  },
  data: () => ({
    currentEvent: {},
    showModal: false,
    nameModel: 'Event',
  }),
  methods: {
    buildPath() {
      return `admin/items/${this.item.id}/events`
    },
    find() {
      this.asyncTemplateSelect()
    },
    show(eventId) {
      const event = this.events.find(e => e.id === eventId)
      this.showModal = true
      this.currentEvent = event
    }
  },
  mixins: [ModelMapper, GetUser],
  name: 'AdminItemEvents',
  props: {
    item: { required: true, type: Object },
  },
}
</script>
